module.exports = __webpack_public_path__ + "static/tools-resources-t-shirt-photo@2x-e17fc39a5b6a62c345d8f75ecbc0a66e.jpg";